import { Size } from '../enums/size.enum';
import { SizeRange } from '../models/size-range.model';

export interface RawSizeRange {
  lowerHipBound: number;
  upperHipBound: number;
}

export const getMeasurementSizeFromWaistHips = (waist: number, hips: number, sizes: Map<number, SizeRange[]> = originalSizes): Size => {
  const ranges = sizes.get(waist);
  let measurementSize: Size = Size['?'];

  if (waist !== -1 && hips !== -1 && ranges) {
    for (const range of ranges) {
      if (hips >= range.lowerHipBound && hips <= range.upperHipBound) {
        measurementSize = range.size;
        break;
      }
    }
  }

  return measurementSize;
};

const originalSizes: Map<number, SizeRange[]> = new Map<number, SizeRange[]>();
originalSizes.set(23, [
  { size: Size.XS, lowerHipBound: 27, upperHipBound: 37 },
  { size: Size.S, lowerHipBound: 38, upperHipBound: 38 },
]);
originalSizes.set(24, [
  { size: Size.XS, lowerHipBound: 27, upperHipBound: 35 },
  { size: Size.S, lowerHipBound: 36, upperHipBound: 39 },
]);
originalSizes.set(25, [
  { size: Size.XS, lowerHipBound: 27, upperHipBound: 33 },
  { size: Size.S, lowerHipBound: 34, upperHipBound: 40 },
]);
originalSizes.set(26, [
  { size: Size.XS, lowerHipBound: 27, upperHipBound: 30 },
  { size: Size.S, lowerHipBound: 31, upperHipBound: 40 },
  { size: Size.M, lowerHipBound: 41, upperHipBound: 41 },
]);
originalSizes.set(27, [
  { size: Size.XS, lowerHipBound: 27, upperHipBound: 28 },
  { size: Size.S, lowerHipBound: 29, upperHipBound: 38 },
  { size: Size.M, lowerHipBound: 39, upperHipBound: 42 },
]);
originalSizes.set(28, [
  { size: Size.XS, lowerHipBound: 27, upperHipBound: 27 },
  { size: Size.S, lowerHipBound: 28, upperHipBound: 36 },
  { size: Size.M, lowerHipBound: 37, upperHipBound: 43 },
]);
originalSizes.set(29, [
  { size: Size.S, lowerHipBound: 28, upperHipBound: 33 },
  { size: Size.M, lowerHipBound: 34, upperHipBound: 43 },
  { size: Size.L, lowerHipBound: 44, upperHipBound: 44 },
]);
originalSizes.set(30, [
  { size: Size.S, lowerHipBound: 29, upperHipBound: 31 },
  { size: Size.M, lowerHipBound: 32, upperHipBound: 42 },
  { size: Size.L, lowerHipBound: 43, upperHipBound: 45 },
]);
originalSizes.set(31, [
  { size: Size.S, lowerHipBound: 30, upperHipBound: 30 },
  { size: Size.M, lowerHipBound: 31, upperHipBound: 41 },
  { size: Size.L, lowerHipBound: 42, upperHipBound: 46 },
]);
originalSizes.set(32, [
  { size: Size.M, lowerHipBound: 31, upperHipBound: 39 },
  { size: Size.L, lowerHipBound: 40, upperHipBound: 45 },
  { size: Size.XL, lowerHipBound: 46, upperHipBound: 47 },
]);
originalSizes.set(33, [
  { size: Size.M, lowerHipBound: 32, upperHipBound: 34 },
  { size: Size.L, lowerHipBound: 35, upperHipBound: 44 },
  { size: Size.XL, lowerHipBound: 45, upperHipBound: 48 },
]);
originalSizes.set(34, [
  { size: Size.M, lowerHipBound: 33, upperHipBound: 33 },
  { size: Size.L, lowerHipBound: 34, upperHipBound: 42 },
  { size: Size.XL, lowerHipBound: 43, upperHipBound: 49 },
  { size: Size['1X'], lowerHipBound: 50, upperHipBound: 50 },
]);
originalSizes.set(35, [
  { size: Size.L, lowerHipBound: 34, upperHipBound: 40 },
  { size: Size.XL, lowerHipBound: 41, upperHipBound: 49 },
  { size: Size['1X'], lowerHipBound: 50, upperHipBound: 51 },
]);
originalSizes.set(36, [
  { size: Size.L, lowerHipBound: 35, upperHipBound: 37 },
  { size: Size.XL, lowerHipBound: 38, upperHipBound: 48 },
  { size: Size['1X'], lowerHipBound: 49, upperHipBound: 51 },
]);
originalSizes.set(37, [
  { size: Size.L, lowerHipBound: 36, upperHipBound: 36 },
  { size: Size.XL, lowerHipBound: 37, upperHipBound: 47 },
  { size: Size['1X'], lowerHipBound: 48, upperHipBound: 52 },
]);
originalSizes.set(38, [
  { size: Size.XL, lowerHipBound: 37, upperHipBound: 46 },
  { size: Size['1X'], lowerHipBound: 47, upperHipBound: 53 },
]);
originalSizes.set(39, [
  { size: Size.XL, lowerHipBound: 38, upperHipBound: 44 },
  { size: Size['1X'], lowerHipBound: 45, upperHipBound: 52 },
  { size: Size['2X'], lowerHipBound: 53, upperHipBound: 54 },
]);
originalSizes.set(40, [
  { size: Size.XL, lowerHipBound: 39, upperHipBound: 42 },
  { size: Size['1X'], lowerHipBound: 43, upperHipBound: 50 },
  { size: Size['2X'], lowerHipBound: 51, upperHipBound: 55 },
]);
originalSizes.set(41, [
  { size: Size.XL, lowerHipBound: 40, upperHipBound: 41 },
  { size: Size['1X'], lowerHipBound: 42, upperHipBound: 48 },
  { size: Size['2X'], lowerHipBound: 49, upperHipBound: 56 },
]);
originalSizes.set(42, [
  { size: Size['1X'], lowerHipBound: 41, upperHipBound: 46 },
  { size: Size['2X'], lowerHipBound: 47, upperHipBound: 56 },
  { size: Size['3X'], lowerHipBound: 57, upperHipBound: 57 },
]);
originalSizes.set(43, [
  { size: Size['1X'], lowerHipBound: 42, upperHipBound: 44 },
  { size: Size['2X'], lowerHipBound: 45, upperHipBound: 56 },
  { size: Size['3X'], lowerHipBound: 57, upperHipBound: 58 },
]);
originalSizes.set(44, [
  { size: Size['1X'], lowerHipBound: 43, upperHipBound: 43 },
  { size: Size['2X'], lowerHipBound: 44, upperHipBound: 55 },
  { size: Size['3X'], lowerHipBound: 56, upperHipBound: 59 },
]);
originalSizes.set(45, [
  { size: Size['2X'], lowerHipBound: 44, upperHipBound: 54 },
  { size: Size['3X'], lowerHipBound: 55, upperHipBound: 60 },
  { size: Size['4X'], lowerHipBound: 61, upperHipBound: 63 },
]);
originalSizes.set(46, [
  { size: Size['2X'], lowerHipBound: 45, upperHipBound: 52 },
  { size: Size['3X'], lowerHipBound: 53, upperHipBound: 60 },
  { size: Size['4X'], lowerHipBound: 61, upperHipBound: 63 },
]);
originalSizes.set(47, [
  { size: Size['2X'], lowerHipBound: 46, upperHipBound: 51 },
  { size: Size['3X'], lowerHipBound: 52, upperHipBound: 60 },
  { size: Size['4X'], lowerHipBound: 61, upperHipBound: 63 },
]);
originalSizes.set(48, [
  { size: Size['2X'], lowerHipBound: 47, upperHipBound: 48 },
  { size: Size['3X'], lowerHipBound: 49, upperHipBound: 60 },
  { size: Size['4X'], lowerHipBound: 61, upperHipBound: 63 },
]);
originalSizes.set(49, [
  { size: Size['3X'], lowerHipBound: 48, upperHipBound: 60 },
  { size: Size['4X'], lowerHipBound: 61, upperHipBound: 63 },
]);
originalSizes.set(50, [
  { size: Size['3X'], lowerHipBound: 49, upperHipBound: 60 },
  { size: Size['4X'], lowerHipBound: 61, upperHipBound: 63 },
]);

export const getPossibleHipSizeFromWaist = (waistSize: number, sizes: Map<number, SizeRange[]> = originalSizes): RawSizeRange | null => {
  const availableSizes = waistSize > 50 ? sizes.get(50) : sizes.get(waistSize);

  if (!availableSizes || availableSizes.length === 0) {
    return null;
  }

  const ret = {
    lowerHipBound: availableSizes[0].lowerHipBound,
    upperHipBound: availableSizes[0].upperHipBound,
  };

  if (availableSizes.length > 0) {
    ret.upperHipBound = availableSizes[availableSizes.length - 1].upperHipBound;
  }

  return ret;
};
